import type Stripe from "stripe";

export const activeLikeStripeSubStatus: Stripe.Subscription.Status[] = [
  "active",
  "past_due",
  "trialing",
  "paused",
] as const;

export type ActiveLikeStripeSubStatus =
  (typeof activeLikeStripeSubStatus)[keyof typeof activeLikeStripeSubStatus];

export const isActiveLikeStripeSubStatus = (
  status: Stripe.Subscription.Status | string,
) => activeLikeStripeSubStatus.includes(status as Stripe.Subscription.Status);
